import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "@activecollab/components";
import { usePrepareFileUrl } from "~/components/Hooks/usePrepareFileUrl.js";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";
import Angie from "../../../utils/angie.jsx";

export const FailedPreview = ({ sizeValue, downloadUrl }) => {
  const { t } = useTranslation();

  const url = usePrepareFileUrl(downloadUrl);

  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <div className="ang_preview_image ang_preview_image_failed" />
          <div className="ang_preview_message">
            <p>{t("Generating preview for this file failed")}</p>
            <p>{t("You can download the file instead")}</p>
            <Link
              href={url}
              variant="primary"
              className="btn btn--pro-2 tw-mt-7"
              download
            >
              {t("Download")} ({Angie.functions.format_file_size(sizeValue)})
            </Link>
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};

FailedPreview.propTypes = mediaElementShape;
